import { GirafeHTMLElement } from '@geogirafe/lib-geoportal/base';
import { Service } from '../service/service';
import { SimpleReportState } from '../../../bs/types';

export default class SimpleReportComponent extends GirafeHTMLElement {
  templateUrl = './template.html';
  styleUrls = ['../../../../node_modules/@geogirafe/lib-geoportal/styles/common.css', '../item-style.css'];

  service!: Service;

  static get observedAttributes() {
    return ['reporttitle', 'reportdescription', 'templateName'];
  }

  reporttitle: string = '';
  templateName: string = '';
  reportdescription: string = '';

  protected get reportState(): SimpleReportState {
    return this.state.extendedState[this.templateName] as SimpleReportState;
  }

  protected get reportConfig() {
    return this.context.configManager.Config.extendedConfig!.reportService;
  }

  constructor() {
    super('simple-report-component');
    this.templateName = this.getAttribute('templateName') || '';
  }

  private initialize() {
    if (!this.state.extendedState[this.templateName]) {
      this.state.extendedState[this.templateName] = {
        currentState: 'inactive'
      };
    }

    this.service = new Service(this.context);
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (oldValue === newValue) return;
    switch (name) {
      case 'reporttitle':
        this.reporttitle = newValue;
        break;
      case 'reportdescription':
        this.reportdescription = newValue;
        break;
      case 'templateName':
        this.templateName = newValue;
        break;
    }
  }

  override connectedCallback() {
    super.connectedCallback();
    this.initialize();
    super.render();
  }

  protected async onReportClick() {
    if (this.reportState.currentState === 'inactive') {
      this.reportState.currentState = 'processing';
      super.render();
      try {
        const resultUrl = await this.service.createReport(this.templateName, '1');
        this.reportState.currentState = 'download';
        this.reportState.downloadUrl = resultUrl;
      } catch (err) {
        this.reportState.currentState = 'error';
        this.reportState.errorMessage = String(err);
      }
    } else if (this.reportState.currentState === 'processing') {
      await this.service.cancelReport();
      this.reportState.currentState = 'inactive';
    } else if (this.reportState.currentState === 'active') {
      this.reportState.currentState = 'inactive';
    } else if (this.reportState.currentState === 'download') {
      window.open(this.reportState.downloadUrl);
      this.reportState.currentState = 'inactive';
    } else if (this.reportState.currentState === 'error') {
      this.reportState.currentState = 'inactive';
    }
    super.render();
  }
}
